import { useRouter } from 'next/router';
import { useCallback, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import { routes } from '@/domains/core/routing/routes/routes.default';
import { useMainCardFetch } from '@/domains/proB2BServices/Wishlists/hooks/useMainCardFetch';

export const useMainListCard = (id: string | number) => {
  const { ref, inView } = useInView();
  const { data, isFetched, refetch } = useMainCardFetch(id, false);
  const { push } = useRouter();

  const goToWishlist = useCallback(
    (wishlistId: string | number) => () => {
      push(`${routes.proServicesWishlists}/${wishlistId}`, undefined, {
        shallow: true,
      });
    },
    [push],
  );

  useEffect(() => {
    if (inView && !isFetched) refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView, isFetched]);

  return {
    products: data?.products || [],
    goToWishlist,
    ref,
  };
};
